import { PaymentMethod } from "@stripe/stripe-js";
import { Case, CaseUpdate } from "@types-runway/case";
import { PaymentProvider } from "@types-runway/billing";

export const SET_CONDITIONS = "SET_CONDITIONS";

export const CREATE_CASE = "CREATE_CASE";
export interface CreateCase {
  type: typeof CREATE_CASE;
  newCase: Case;
}

export const UPDATE_CASE = "UPDATE_CASE";
export interface UpdateCase {
  type: typeof UPDATE_CASE;
  caseId: number;
  isAuth: boolean;
  updateBody: CaseUpdate;
}

export const PAY_CASE = "PAY_CASE";
export interface PayCase {
  type: typeof PAY_CASE;
  newCaseId: number;
  paymentMethods: PaymentMethod[];
  pricing: {
    priceId: string;
    productId: string;
    provider: string;
  };
  customerId?: string;
  promoCodeId?: string;
  manual?: boolean;
}

export const SEND_CASE = "SEND_CASE";
export interface SendCase {
  type: typeof SEND_CASE;
  newCase: Case;
  isPlus: boolean;
}

export const REQUEST_CASES = "REQUEST_CASES";
export interface RequestCases {
  type: typeof REQUEST_CASES;
  userId: string;
}

export const REFRESH_CASES = "REFRESH_CASES";
export interface RefreshCases {
  type: typeof REFRESH_CASES;
  userId: string;
}

export const REQUEST_ORDER_INVOICE = "REQUEST_ORDER_INVOICE";
export interface RequestOrderInvoice {
  type: typeof REQUEST_ORDER_INVOICE;
  orderId: number; // Runway ID
  caseId: number;
}

export const PAY_ORDER = "PAY_ORDER";
export interface PayOrder {
  type: typeof PAY_ORDER;
  orderId: string; // Shared ID
  caseId: number;
  invoiceProvider?: PaymentProvider; // Creates the order's invoice first.
}

// Creates the order's Stripe invoice (no charge) and opens the review of its amount.
export const PREPARE_CARD_PAYMENT = "PREPARE_CARD_PAYMENT";
export interface PrepareCardPayment {
  type: typeof PREPARE_CARD_PAYMENT;
  orderId: string; // Shared ID
  caseId: number;
}

export const CREATE_CASE_INVOICE = "CREATE_CASE_INVOICE";

export interface InvoicePricing {
  priceId: string;
  productId: string;
  provider: PaymentProvider;
}

export interface InvoiceRedirects {
  successUrl: string;
  cancelUrl: string;
}

export interface CreateCaseInvoice {
  type: typeof CREATE_CASE_INVOICE;
  caseId: number;
  pricing: InvoicePricing;
  promoCodeId?: string;
  customerId?: string;
  redirects?: InvoiceRedirects;
}
